<!-- HEADER -->
<section class="home__header">
    <div class="header__content wrapper">
        <a class="header__logo" [href]="" alt="Explorer Yummypets">
            <img [src]="logoSVG" />
        </a>
       <h1 class="header__title">
            <span class="clip-from-top">We connect.&nbsp;</span>
            <span class="clip-from-bottom ">We talk.&nbsp;</span><br />
            <span class="clip-from-top"> We pet care.</span>
        </h1>
        <p class="header__desc" i18n="@@landing.header.desc">
            Explorer is redefining pet care by listening to what matters most — pet owners like you.
        </p>

        <div class="header__cta mt-10">
            <a class="btn btn--primary" [routerLink]="[isAuthenticated ? '/dashboard' : '/signup']" i18n="@@landing.header.btn.participate">Participate</a>
            <a class="btn btn--tol" [routerLink]="['/panel']" i18n="@@landing.header.btn.hiw">How it works</a>
        </div>
    </div>
</section>


<!-- COUNTRIES -->
<section class="home__countries" exScrollAnimation>

    <div class="home__wrapper countries__wrapper">

        <div class="countries__picture"></div>
        <div class="countries__content mt-5">

            <h2 i18n="@@landing.countries.title">We are currently looking for pet owners from</h2>

            <ul class="countries__list mt-8">
                <li>
                    <a aria-disabled="true">
                        <i class="icon icon--bg i--FR"></i>
                        <span class="ml-2" i18n="@@global.country.france">France</span>
                    </a>
                </li>
                <li>
                    <a aria-disabled="true">
                        <i class="icon icon--bg i--UK"></i>
                        <span class="ml-2" i18n="@@global.country.uk">United Kingdom</span>
                    </a>
                </li>
                <li>
                    <a aria-disabled="true">
                        <i class="icon icon--bg i--US"></i>
                        <span class="ml-2" i18n="@@global.country.us">United States</span>
                    </a>
                </li>
                <li>
                    <a aria-disabled="true">
                        <i class="icon icon--bg i--AU"></i>
                        <span class="ml-2" i18n="@@global.country.au">Australia</span>
                    </a>
                </li>
                <li>
                    <a aria-disabled="true">
                        <i class="icon icon--bg i--CA"></i>
                        <span class="ml-2" i18n="@@global.country.canada">Canada</span>
                    </a>
                </li>
                <li>
                    <a aria-disabled="true">
                        <i class="icon icon--bg i--BR"></i>
                        <span class="ml-2" i18n="@@global.country.brazil">Brazil</span>
                    </a>
                </li>
                <li>
                    <a aria-disabled="true">
                        <i class="icon icon--bg i--MX"></i>
                        <span class="ml-2" i18n="@@global.country.mexico">Mexico</span>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</section>

<!-- HOW IT WORKS -->
<section class="home__hiw" exScrollAnimation>
    <div class="home__wrapper">
    <h2 i18n="@@landing.hiw.title">How it works</h2>
    <div class="hiw__items mt-5">
        <div class="hiw__item">
            <div class="hiw__rect">
                <i class="icon i--panel i--onyx i--md"></i>
                <p class="hiw__text" i18n="@@landing.hiw.create">Create an account to join the panel.</p>
            </div>
        </div>
        <div class="hiw__item">
            <div class="hiw__rect">
                <i class="icon i--hands i--onyx i--md"></i>
                <p class="hiw__text" i18n="@@landing.hiw.share">Share your opinion by participating in our surveys.</p>
            </div>
        </div>
        <div class="hiw__item">
            <div class="hiw__rect">
                <i class="icon i--survey_complex i--onyx i--md"></i>
                <p class="hiw__text" i18n="@@landing.hiw.reward">Earn rewards for every survey you complete.</p>
            </div>
        </div>
        <div class="hiw__item">
            <div class="hiw__rect">
                <i class="icon i--nature i--onyx i--md"></i>
                <p class="hiw__text" i18n="@@landing.hiw.contribute">We donate free meals to animals in need.</p>
            </div>
        </div>
    </div>
    </div>
</section>

<section class="home__testimonials" exScrollAnimation>
    <div class="home__wrapper">

        <h2 i18n="@@landing.members.title">What our members are saying</h2>

        <div class="testimonials__carousel">
            <article class="testimonial-card">
            <p i18n="@@landing.enora.opinion">
                I love to participate to Explorer survey and give my opinion on the everyday life of my pets.
            </p>
            <div class="author">
                <img src="https://d2xec21l9srv8z.cloudfront.net/v3/users-avatar/avatar01.jpg" alt="Enora">
                <div>
                <strong i18n="@@landing.enora.country">Enora from Brazil</strong><br>
                <span i18n="@@landing.enora.pet">Proud owner of Gizmo</span>
                </div>
            </div>
            </article>

            <article class="testimonial-card">
            <p i18n="@@landing.emma.opinion">
                How exciting! Thank you so much! My dog will enjoy the extra treats I will buy her with it.
            </p>
            <div class="author">
                <img src="https://d2xec21l9srv8z.cloudfront.net/v3/users-avatar/avatar02.jpg" alt="Emma">
                <div >
                <strong i18n="@@landing.emma.country">Emma from UK</strong><br>
                <span i18n="@@landing.emma.pet">Proud owner of Osiris</span>
                </div>
            </div>
            </article>

            <article class="testimonial-card">
            <p  i18n="@@landing.james.opinion">
                Explorer is the best way to share my opinion on the future of the pet food industry and help shelters in need at the same time.
            </p>
            <div class="author">
                <img src="https://d2xec21l9srv8z.cloudfront.net/v3/users-avatar/avatar03.jpg" alt="James">
                <div>
                <strong i18n="@@landing.james.country">James from USA</strong><br>
                <span  i18n="@@landing.james.pet">Proud owner of Oromo</span>
                </div>
            </div>
            </article>
        </div>
    </div>
</section>


<section class="home__partners" exScrollAnimation>
    <div class="home__wrapper">
        <h2 i18n="@@landing.partners.title">Our gift card partners</h2>

        <div class="partners__logos">
            <img src="https://d2xec21l9srv8z.cloudfront.net/v3/logos/logo_petz.png" alt="Peta">
            <img src="https://d2xec21l9srv8z.cloudfront.net/v3/logos/logo_chewy.png" alt="Chewy">
            <img src="https://d2xec21l9srv8z.cloudfront.net/v3/logos/logo_petsmart.png" alt="PetSmart">
            <img src="https://d2xec21l9srv8z.cloudfront.net/v3/logos/logo_petco.png" alt="Petco">
            <img src="https://d2xec21l9srv8z.cloudfront.net/v3/logos/logo_zoomalia.png" alt="Zoomalia">
        </div>

        <p class="partners__note" i18n="@@landing.partners.desc">
            Take part in our surveys. For every survey, $500 worth of gift cards are awarded to randomly selected participants.
        </p>
    </div>
</section>

<!-- APP -->
<section class="home__app home__wrapper" exScrollAnimation>

    <div class="app__picture"> 
        <img [src]="cdn.v3 + 'apps/Illus_App-'+ ((currentCountry() || 'en') | uppercase) + '.png'" />
    </div>
    <div class="app__content">
        <h2 i18n="@@landing.app.title">Get the app</h2>
        <p  i18n="@@landing.app.desc" class="mt-5">Take part in surveys and answer our weekly questions — right from your phone.</p>
        <div class="app__badges mt-8">
            <a class="app-android" href="https://apps.apple.com/app/6478925036">
                <img [src]="cdn.v3 + 'badges/svg/AppStore_' + locale +'.svg'"/>
            </a>
            <a class="app-ios ml-5" href="https://play.google.com/store/apps/details?id=com.yummypets.explorer">
                <img [src]="cdn.v3 + 'badges/svg/GooglePlay_' + locale +'.svg'"/>
            </a>
        </div>
    </div>

</section>


